export default "__VITE_ASSET__8c1e5f58__"